export const Transitions = {
  micro: '0.2s ease-out',
}
